import {IS_DEV} from '@/constants/env'

const initSentry = () => {
    if (!IS_DEV) {
        require('@sentry/nextjs').init({
            dsn: 'https://b8ead82a11204e05ab5a8b20f6767914@sentry.baijia.com/1140',
            environment: process.env.APP_ENV,
            tracesSampleRate: 1.0,
            integrations: [
            // 配置参考这里，只在可以接受对应链路追踪请求头的的域名上，添加 sentry-trace 等
                new (require('@sentry/tracing').Integrations.BrowserTracing)({
                    tracingOrigins: [location.origin],
                }),
            ],
        })
    }
}

export default initSentry
